// RestaurantStatsCard.tsx

import { Card, CardContent } from "../ui/card";
import {
  Calendar,
  DollarSign,
  Repeat,
  Zap,
  Star as StarIcon,
  TrendingUp,
  TrendingDown,
  Minus,
} from "lucide-react";

interface RestaurantStatsCardProps {
  title: string;
  value: string;
  icon: "bookings" | "revenue" | "rating" | "timesChosen" | "karmaPower";
  trend: "up" | "down" | "stable";
  trendValue: string;
  suffix?: string;
}

const RestaurantStatsCard = ({
                               title,
                               value,
                               icon,
                               trend,
                               trendValue,
                               suffix = "",
                             }: RestaurantStatsCardProps) => {
  let IconComponent;
  let iconColor;
  let iconBg;

  switch (icon) {
    case "bookings":
      IconComponent = Calendar;
      iconColor = "text-blue-500";
      iconBg = "bg-blue-100 dark:bg-blue-900";
      break;
    case "revenue":
      IconComponent = DollarSign;
      iconColor = "text-green-500";
      iconBg = "bg-green-100 dark:bg-green-900";
      break;
    case "timesChosen":
      IconComponent = Repeat;
      iconColor = "text-purple-500";
      iconBg = "bg-purple-100 dark:bg-purple-900";
      break;
    case "karmaPower":
      IconComponent = Zap;
      iconColor = "text-yellow-400";
      iconBg = "bg-yellow-100 dark:bg-yellow-900";
      break;
    case "rating":
    default:
      IconComponent = StarIcon;
      iconColor = "text-yellow-500";
      iconBg = "bg-yellow-100 dark:bg-yellow-900";
      break;
  }

  let TrendIcon;
  let trendColor;
  switch (trend) {
    case "up":
      TrendIcon = TrendingUp;
      trendColor = "text-green-500";
      break;
    case "down":
      TrendIcon = TrendingDown;
      trendColor = "text-red-500";
      break;
    case "stable":
    default:
      TrendIcon = Minus;
      trendColor = "text-gray-500 dark:text-gray-400";
      break;
  }

  return (
      <Card>
        <CardContent className="flex flex-col p-6">
          <div className="flex items-center justify-between">
            <div className="text-sm font-medium text-gray-500 dark:text-gray-400">
              {title}
            </div>
            <div
                className={`flex h-8 w-8 items-center justify-center rounded-full bg-opacity-20 dark:bg-opacity-30 ${iconBg}`}
            >
              <IconComponent className={`h-4 w-4 ${iconColor}`} />
            </div>
          </div>
          <div className="mt-2 text-3xl font-bold text-gray-800 dark:text-white">
            {value}
            {suffix}
          </div>
          {trendValue && (
              <div className="mt-2 flex items-center">
                <TrendIcon className={`mr-1 h-4 w-4 ${trendColor}`} />
                <span className={`text-sm font-medium ${trendColor}`}>
              {trendValue} {trend === "stable" ? "No change" : "from last month"}
            </span>
              </div>
          )}
        </CardContent>
      </Card>
  );
};

export default RestaurantStatsCard;
